// extracted by mini-css-extract-plugin
export default {"highlight_description":"Description_highlight_description__8F2qI","center_wrapper":"Description_center_wrapper__hw7Fu","h2":"Description_h2__u1YM3"};